import RestService from '@core/services/broadcast/_private/RestService';
import BroadcastMapper from '@core/mappers/broadcast/BroadcastMapper';
import Broadcast from '@core/models/broadcast/Broadcast';
import IBroadcastDto from '@core/mappers/broadcast/dtos/IBroadcastDto';

export default class BroadcastService {
    private readonly restService = new RestService();
    private readonly broadcastMapper = new BroadcastMapper();

    public async getBroadcasts(): Promise<Broadcast[]> {
        const broadcasts: IBroadcastDto[] = await this.restService.getBroadcasts();
        return this.broadcastMapper.map(broadcasts);
    }
}

export const broadcastService = new BroadcastService();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/broadcast/BroadcastService.ts